import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WorkspaceMeService } from '../services';

/**
 * Guard di capability per la rotta /managetemplates (feature C).
 *
 * Consente l'accesso solo se l'utente puo gestire almeno un livello di template
 * (Tenant o System). Carica /v1/me se non ancora in cache; in caso di errore o
 * di mancanza di permessi reindirizza a /dashboard.
 */
export const workspaceManageTemplatesGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const workspaceMe = inject(WorkspaceMeService);
  const router = inject(Router);

  const allowOrRedirect = (): boolean | UrlTree =>
    workspaceMe.canManageAny() ? true : router.createUrlTree(['/dashboard']);

  if (workspaceMe.me()) {
    return of(allowOrRedirect());
  }

  return workspaceMe.load().pipe(
    map(() => allowOrRedirect()),
    catchError(() => of(router.createUrlTree(['/dashboard'])))
  );
};
